export * from './app-sidebar.component';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/components/app-sidebar/index.ts